import { toast } from "sonner";

/**
 * Copies the current page URL to clipboard and shows a success toast
 */
export const copyLinkToClipboard = async (): Promise<void> => {
    try {
        await navigator.clipboard.writeText(window.location.href);
        toast.success("Link copiado com sucesso!", {
            description: "Agora você pode compartilhar em qualquer lugar"
        });
    } catch (err) {
        console.error("Failed to copy link:", err);
        toast.error("Erro ao copiar link", {
            description: "Tente novamente ou copie manualmente da barra de endereços"
        });
    }
};
